import { useEffect, useState } from "react";
import queryString from 'query-string';
import history from "../../history";
import { Table, Card, Row, Spin, Col, Button, Tooltip as TooltipAnd, Modal } from 'antd';
import { errorMessage } from "../Helpers/Util";
import getFilesWithSigners from "../../services/getFilesWithSigners";
import ExcelExport from "../ExcelExport";
import { FileExcelOutlined } from "@ant-design/icons";


const parsed = queryString.parse(history.location.search);


const TumBelgelerveImzalarForm = () => {
  const [spining, setSpining] = useState(false);
  const [data, setData] = useState([]);

  const load = async () => {
    setSpining(true);

    let getFilesWithSignersRequest = {
      basvuruId: parseInt(parsed.basvuruId),
      parentBasvuruId: parseInt(parsed.parentBasvuruId),
      fileTypeIdList: parsed.fileTypeIdList.split(','),
      signedOnly: parsed.signedOnly,
    };

    await getFilesWithSigners(getFilesWithSignersRequest).then(async res => {
      if (res.data.success) {
        await setTableData(res.data.result);    

      } else {
        errorMessage(res.data.message)
      }
    }).catch(err => {
      errorMessage(err.message)
    });

    setSpining(false);
  }


  const setTableData = async (res) => {

    let tableData = [];
    await res.relatedBasvurus.map((result) => {
         if(result.basvuruFiles.length == 0){
          tableData.push({
             parentBasvuruId: res.parentBasvuruId,
             basvuruId : result.basvuruId,
             altSurecAdi: result.altSurecTipiAdi,
             belgeAdi : res.belgeTuruAdi,
             fileTypeName : "-",
             fileName : "-",
             Adsoyad :  "-",
             Tckn : "-"
           });
         }else{      
           result.basvuruFiles.map((files) => {
             if(files.signers.length == 0){
              tableData.push({
                 parentBasvuruId: res.parentBasvuruId,
                 basvuruId : result.basvuruId,
                 altSurecAdi: result.altSurecTipiAdi,
                 belgeAdi : res.belgeTuruAdi,
                 fileTypeName : files.fileTypeName,
                 fileName : files.fileName,
                 Adsoyad :  "-",
                 Tckn : "-"
               });
             }else{
               files.signers.map((signers) => { 
                tableData.push({
                   parentBasvuruId: res.parentBasvuruId,
                   basvuruId : result.basvuruId,
                   altSurecAdi: result.altSurecTipiAdi,
                   belgeAdi : res.belgeTuruAdi,
                   fileTypeName : files.fileTypeName,
                   fileName : files.fileName,
                   Adsoyad :  signers.Adsoyad,
                   Tckn : signers.Tckn
                 });
     
               });
             }
           })
         }   
       })

       await setData(tableData);
      
       return true;
  }

  useEffect(() => {
    load();
    
  }, []);





  const columns = [
    {
      title: 'Ana Başvuru No',
      dataIndex: 'parentBasvuruId',
      key: 'parentBasvuruId',
     
    },
    {
      title: 'Başvuru No',
      dataIndex: 'basvuruId',
      key: 'basvuruId',
    },
    {
      title: 'Belge Adi',
      dataIndex: 'belgeAdi',
      key: 'belgeAdi',
    },
    {
      title: 'Alt Süreç',
      dataIndex: 'altSurecAdi',
      key: 'altSurecAdi',
    },
    {
      title: 'Tipi',
      dataIndex: 'fileTypeName',
      key: 'fileTypeName',
    },
    {
      title: 'Dosya Adı',
      dataIndex: 'fileName',
      key: 'fileName'
    },
    {
      title: 'Adı Soyadı',
      dataIndex: 'Adsoyad',
      key: 'Adsoyad'
    },
    {
      title: 'TCKN',
      dataIndex: 'Tckn',
      key: 'Tckn'
    }
  ].filter(item => !item.hidden);



  return <Spin tip={"Veriler Yükleniyor"} spinning={spining} >
    <Card
      style={{ margin: "20px" }}
      title={<h4 style={{ fontWeight: "bolder", color: "white" }}>Tüm Belgeler</h4>}
      className="ant-card-head-title-large">
      <Row gutter={16}>
        <Col span={24}>
          {data != null && data.length > 0 &&
            <Table bordered
              dataSource={data}
              columns={columns}
              title={() => <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h3 style={{ fontWeight: "bolder" }}> Belge Listesi </h3>
              <ExcelExport
                fileName={'Rapor' }
                downloadButton={<Button type="link" icon={<FileExcelOutlined style={{ color: "green" }} />}> Excele Aktar </Button>}
                sheets={[{ data: data, name: 'Rapor', keyTitles: columns }]} />                
              </div>
              }
              pagination={{
                showSizeChanger: true
              }}            
              scroll={{ y: 750 }}
            />
          }
        </Col>
      </Row>
    </Card>
  </Spin>
};
export default TumBelgelerveImzalarForm;